<template>
    <div class="theme-input hrm_input">
        <label class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400">{{
            trans("lang.labels.data_provider_type") }}
        </label>
        <div class="relative mt-2">
            <VueMultiselect :key="componentKey" class="hrm-vuemultiselect" v-model="filterData[filterItem.models]"
                @clear="onClearDataProviderType" :options="filterItem.dataProviderTypes"
                @select="onChangeDataProviderType" :placeholder="trans('lang.labels.Select')" label="name"
                valueProp="id" :searchable="true" />
        </div>
    </div>
</template>
<script setup>
import { onMounted, ref } from 'vue';
import VueMultiselect from "@vueform/multiselect";
import { trans } from '@/helpers';

const props = defineProps({
    filterItem: { type: Object },
    filterData: { type: Object, required: true },
});

const componentKey = ref(1)

const onChangeDataProviderType = async () => {
}

const onClearDataProviderType = () => {
    props.filterData[props.filterItem.DataProviderType] = null;
    props.filterItem.dataProviders = [];
    componentKey.value += 1;
}


const getDataProvierType = async () => {
    try {
        const response = await axios.get(route("datacenter.data-provider-types.index"))
        props.filterItem.dataProviderTypes = [...response.data.data];
        props.filterItem.dataProviderTypes.push(
            {
                name: 'Candidate',
                id: "candidate",
            },
            {
                name: 'University',
                id: "university",
            },
        );
    } catch (error) {
        console.error("Error fetching work sources profiles:", error);
    }
};

onMounted(async () => {
    if (props.filterItem.dataProviderTypes && props.filterItem.dataProviderTypes.length == 0) {
        await getDataProvierType();
    }
});


</script>